<template>
<div class="container">
    <div class="aftersale">
        <img src="../../../assets/icon/refund.png" alt="" width="100%">
        <div class="sale">
            <span class="sale-tk">退款成功</span>
            <!-- <span class="sale-bq">退款账号不存在</span> -->
        </div>
    </div>
    <div class="refundinformation">
        <div class="item">退款信息</div>
        <div class="commodity">
            <div class="commodity-img">
                <div class="comimg">
                    <img :src="afterSaleInfo.goodsImgUrl" alt="" width="100%">
                </div>
                <div class="commodity-content">
                    <span class="title">{{afterSaleInfo.goodsName}}</span>
                    <!--<span class="text">黑色和米白色桑蚕丝斜纹</span>-->
                    <span class="count">x{{afterSaleInfo.goodsNum}}</span>
                </div>
            </div>
            <div class="commodity-information">
                <div class="cominformation">
                    <span class="comtime">申请时间：</span>
                    <span class="comdate">{{afterSaleInfo.applyTime}}</span>
                </div>
                <div class="cominformation">
                    <span class="comtime">处理方式：</span>
                    <span class="examine" v-if=" afterSaleInfo.status == '1010' ">处理中</span>
                    <span class="examine" v-else-if=" afterSaleInfo.status == '1030' ">审核通过</span>
                    <span class="examine" v-else-if=" afterSaleInfo.status == '1040' ">审核拒绝</span>
                    <span class="examine" v-else-if=" afterSaleInfo.status == '1070' ">退款成功</span>
                </div>
                <div class="cominformation">
                    <span class="comtime">退款金额：</span>
                    <span class="comdate">¥{{afterSaleInfo.returnRealAmount}}</span>
                </div>
                <div class="cominformation">
                    <span class="comtime">退款原因：</span>
                    <span class="comdate">{{afterSaleInfo.applyReason}}</span>
                </div>

            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    afterDetail
} from '@/api/api';

export default {
    data() {
        return {
            isRequestFinished: false, // 请求是否结束
            afterSaleInfo: {
                afterSaleNo: '', // 退款编号
                afterSaleType: null, // 售后类型
                status: null, // 售后订单状态
                applyTime: '', // 申请时间
                returnRealAmount: '', // 退款金额
                applyReason: '', // 售后原因
                orderNo: '', // 订单编号
                orderTime: '', // 下单时间
                goodsImgUrl: '', // 商品图片
                goodsNum: '', // 商品数量
                goodsName: '' // 商品名称
            }
        }
    },
    created() {
        // 获取售后订单编号
        if (this.$route.query.afterSaleNo && this.$route.query.afterSaleNo != '') {
            this.afterSaleNo = this.$route.query.afterSaleNo;
            this.getData(this.afterSaleNo);
        } else {
            this.$router.go(-1);
        }
    },
    methods: {
        // 获取售后详情
        async getData(afterSaleNo) {
            const params = {
                afterSaleNo: afterSaleNo
            };
            const res = await afterDetail(params);
            if (res.code === '0000') {
                this.afterSaleInfo = res.data
            } else {
                this.$toast(res.message);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    .aftersale {
        position: relative;
        margin-bottom: 20px;

        .sale {
            position: absolute;
            left: 40px;
            top: 50px;

            span {
                display: block;
            }

            .sale-tk {
                font-size: 42px;
                font-weight: 400;
                color: #ffffff;
                line-height: 59px;
                padding-bottom: 21px;
            }

            .sale-bq {
                font-size: 30px;
                font-weight: 400;
                color: #ffffff;
                line-height: 42px;
            }
        }
    }

    .refundinformation {
        background: #fff;
        padding: 0 20px;

        .item {
            padding: 30px 0 14px 20px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
            border-bottom: 1px solid #999999;
        }

        .commodity {
            padding: 14px 20px 80px 20px;

            .commodity-img {
                display: flex;

                span {
                    display: block;
                }

                .commodity-content {
                    flex: 2;
                    padding-left: 20px;

                    .title {
                        font-size: 28px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 40px;
                        padding-bottom: 10px;
                    }

                    .text {
                        font-size: 26px;
                        font-weight: 500;
                        color: #999999;
                        line-height: 37px;
                        padding-bottom: 33px;
                    }

                    .count {
                        font-size: 28px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 40px;
                        text-align: right;
                    }
                }

                .comimg {

                    width: 180px;
                    height: 180px;

                    img {
                        border-radius: 8px;
                    }

                }
            }

            .commodity-information {
                padding-top: 40px;

                .cominformation {
                    display: flex;
                    padding-bottom: 20px;

                    span {
                        display: block;
                        font-size: 28px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 40px;
                    }

                    .comtime {
                        // flex: 1;
                        padding-right: 60px;
                    }

                    .comdate {
                        flex: 2;
                    }
                }
            }
        }

    }
}
</style>
